<template>
  <div>
    <el-dialog title="同步日志信息" :visible.sync="visible" :width="width">
      <el-table
        :data="logsList"
        v-loading="tableLoading"
        stripe
        border
        height="400px"
        style="width: 100%"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <template #empty>
          <p>{{ tableLoading == true ? "数据加载中" : "暂无数据" }}</p>
        </template>
        <el-table-column
          prop="username"
          label="操作人"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="title"
          label="操作"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="操作时间"
          width="160"
          :formatter="columnDateFormat"
        ></el-table-column>
        <el-table-column prop="note" label="结果"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import { getLogsList } from "@/api/yunpan";
import { dateFormat } from "@/utils/date";
export default {
  name: "logsViews",
  props: {
    width: {
      type: String,
      default: "900px",
    },
  },
  data() {
    return {
      logsList: [],
      visible: false,
      tableLoading: false,
    };
  },
  methods: {
    columnDateFormat(row, column, cellValue, index) {
      const dateValue = row[column.property];
      if (dateValue != null) {
        return dateFormat("YYYY-mm-dd HH:MM:SS", new Date(dateValue));
      }
    },
    initData(id) {
      this.visible = true;
      this.tableLoading = true;
      getLogsList(id).then((res) => {
        this.tableLoading = false;
        if (res.code == 0) {
          this.logsList = res.data;
        }
      });
    },
  },
};
</script>
